import { TableCell, TableCellProps } from "@mui/material"
import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface CellProps extends TableCellProps {
    children: ReactNode
}

export default function Cell({ children, ...rest }: CellProps) {
    return (
        <TableCell 
            {...rest}
            className={twMerge("", rest.className)} 
            style={{
                borderBottom: '1px solid #e2e2e2',
                color: '#151A25',
                ...rest.style
            }}
            sx={{ 
                padding: '10px',
                ...rest.sx,
            }} 
        >
            {children}
        </TableCell>
    )
}